<template>
  <div class="flex-row align-items-center selection-thumbnails ">
    <a-tooltip
        v-for="hasAttachable in thumbnails"
        :key="hasAttachable.id"
    >
      <template #title>{{ hasAttachable.name }}</template>
      <a-avatar
          class="avatar"
          :src="avatarUri(hasAttachable.id)"
          :size="30"
          :style="{ border: '2px solid white' }">
        {{ getInitials(hasAttachable.name) }}
      </a-avatar>
    </a-tooltip>

    <span v-if="automation.unprocessed_result_count" class="pl-xxs">
      {{ automation.unprocessed_result_count }} in verzendlijst
    </span>
  </div>
</template>

<script>
export default {
  name: "AutomationSelectionSummary",
  props: {
    automation: {
      type: Object,
      required: true
    }
  },
  methods:  {
    avatarUri (customerId) {
      return '/customer/' + customerId + '/avatar'
    },
    getInitials (name) {
      return name.split(' ').map(n => n[0]).join('')
    }
  },
  computed: {
    thumbnails() {
      return this.automation?.search_thumbnail?.data || []
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/_default.scss';

.selection-thumbnails  {
  .avatar {
    position: relative;
    margin-left: -$spacing-xs;
  }
  margin-left: $spacing-xs;
}
</style>
